import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLangPath } from "../../hooks/useLangPath";

const SideMenu = () => {
    const { t } = useTranslation();
    const getPath = useLangPath();

    return (
        <div className="side-menu" id="sideMenu">
            <div className="overlay" id="overlay"></div>
            <a href="javascript:void(0)" className="close-btn" id="closeBtn">
                <i className="fa fa-close"></i> close
            </a>
            <div className="menu-content">
                <Link to={getPath('')} className="logo">
                    <img src="/assets/images/logo.png" alt="WIZ Engineering" style={{ maxHeight: '40px', width: 'auto' }} />
                </Link>
                <div className="sidebar-menu">
                    <h4 className="title">{t('nav_contact')}</h4>
                    <p>Engineering Intelligent Systems <br/> for the Real World</p>
                    <a href="mailto:info@wiz.com" className="email">info@wiz.com</a>
                    
                    <Link to={getPath('/contact')} className="ibt-btn ibt-btn-outline-3 ibt-btn-rounded">
                        <span>{t('btn_get_in_touch')}</span>
                    </Link>
                </div>
             </div>
        </div>
    );
}

export default SideMenu;